import React from 'react';
import { Zap, Shield, CreditCard, AlertTriangle } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { Countdown } from '../ui/Countdown';
const items = [{
  name: 'Tom 1 — Faza Zero',
  value: '120 zł'
}, {
  name: 'Tom 2 — Moduł Inicjacji U12',
  value: '120 zł'
}, {
  name: 'Tom 3 — Moduł Rozwoju U14',
  value: '120 zł'
}, {
  name: 'Tom 4 — Moduł Konsolidacji U16',
  value: '120 zł'
}, {
  name: 'Tom 5 — Moduł Rywalizacji U18',
  value: '120 zł'
}, {
  name: 'Tom 6 — Kalendarz 365',
  value: '120 zł'
}, {
  name: '6 Bonusów specjalnych',
  value: '960 zł'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-206">
      <div className="max-w-4xl mx-auto" data-id="element-207">
        <div className="bg-[#1A3257] rounded-2xl shadow-xl overflow-hidden ring-2 ring-gold-accent ring-offset-2 ring-offset-[#0A1628] relative" data-id="element-208">
          <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-[#E63946] text-white px-4 py-2 md:px-6 md:py-3 rounded-full font-bold text-sm md:text-xl shadow-lg z-10 transform rotate-3" data-id="element-209">
            ZNIŻKA
          </div>

          <div className="bg-gradient-to-br from-gold-accent to-gold-light p-6 md:p-8 text-center" data-id="element-210">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-[#0A1628] mb-1 md:mb-2 pr-16 md:pr-0" data-id="element-211">
              🏆 Opcja najpopularniejsza — wybierana najczęściej
            </h2>
          </div>

          <div className="p-6 md:p-12" data-id="element-212">
            <h3 className="text-xl md:text-2xl font-display font-bold text-white mb-4 md:mb-6 text-center" data-id="element-213">
              Podsumowanie wartości:
            </h3>

            <div className="mb-6 md:mb-8 rounded-xl overflow-hidden border border-[#1E3A5F]" data-id="element-214">
              {items.map((item, index) => <div key={index} className={`flex justify-between items-center px-4 py-2.5 md:py-3 text-sm md:text-base ${index % 2 === 0 ? 'bg-[#112240]' : 'bg-[#1A3257]'}`} data-id="element-215">
                  <span className="text-[#E8EAF0]" data-id="element-216">{item.name}</span>
                  <span className="font-bold text-white" data-id="element-217">→ {item.value}</span>
                </div>)}
            </div>

            <div className="border-t-2 border-[#1E3A5F] pt-6 mb-6 md:mb-8" data-id="element-218">
              <div className="flex justify-between items-center mb-4 px-2" data-id="element-219">
                <span className="text-lg md:text-xl font-bold text-[#9BA3B5]" data-id="element-220">
                  Łączna wartość rzeczywista:
                </span>
                <span className="text-xl md:text-2xl font-bold text-[#9BA3B5] line-through" data-id="element-221">
                  1 680 zł
                </span>
              </div>

              <div className="text-center my-6 md:my-8" data-id="element-222">
                <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-223">
                  🔥 Tylko dzisiaj
                </p>
                <div className="text-6xl sm:text-7xl md:text-8xl font-display font-bold text-gold-accent mb-4 drop-shadow-md" data-id="element-224">
                  73 zł
                </div>
                <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-[#9BA3B5]" data-id="element-225">
                  <span className="flex items-center gap-1" data-id="element-226">
                    <CreditCard className="w-4 h-4" data-id="element-227" />
                    Jednorazowa płatność
                  </span>
                  <span className="flex items-center gap-1" data-id="element-228">
                    <Zap className="w-4 h-4" data-id="element-229" />
                    Natychmiastowy dostęp
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-[#E63946]/10 border border-[#E63946]/30 rounded-xl p-4 mb-6 md:mb-8 flex items-start gap-3" data-id="element-230">
              <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 text-[#E63946] flex-shrink-0 mt-0.5" data-id="element-231" />
              <div data-id="element-232">
                <p className="font-bold text-[#E63946] mb-1 text-sm md:text-base" data-id="element-233">
                  ⚠️ Tylko dla pierwszych 200 nauczycieli
                </p>
                <p className="text-[#E8EAF0] text-xs md:text-sm" data-id="element-234">
                  Po przekroczeniu tej liczby cena wraca do ceny regularnej
                </p>
              </div>
            </div>

            <a href="https://polonia.recursopack.com/cart/41012708802609:1" className="block mb-5" data-id="element-235">
              <CTAButton size="large" className="w-full" data-id="element-236">
                🏐 TAK! Chcę gotowy plan na 40 tygodni — 73 ZŁ
              </CTAButton>
            </a>

            <div className="flex justify-center mb-5" data-id="element-237">
              <Countdown data-id="element-238" />
            </div>

            <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-[#9BA3B5]" data-id="element-239">
              <span className="flex items-center gap-1" data-id="element-240">
                <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-241" />
                Natychmiastowy dostęp
              </span>
              <span className="flex items-center gap-1" data-id="element-242">
                <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-243" />
                Jednorazowa płatność
              </span>
              <span className="flex items-center gap-1" data-id="element-244">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-245" />
                Gwarancja 7 dni
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}